import React, { useState, useContext } from "react";
import { getSelectedPartner } from "../../Utils/localStore";
import ContextApi from "../../context/ContextApi";

const PartnerForm = ({onBack, onContinue}) => {
    const {setPartner, partner} = useContext(ContextApi)
  const [partnerData, setPartnerData] = useState(partner);
  const handleFormSubmit = (e) => {
    e.preventDefault();
  };
  const handleFormUpdate = (e) => {
    const { id, value } = e.target;
    setPartnerData({
      ...partnerData,
      [id]: value,
    });
  };

  const updateFormData = async (e) => {
    e.preventDefault()
    await setPartner(partnerData)
  }
  return (
    <>
      <div
        id="appt_form2"
        className={`font-euclid-circular-a w-full lg:p-8 p-4 sm:p-8 md:p-12 lg:w-[700px] overflow-hidden overflow-y-auto border rounded-md`}
      >
        <div className="h-[700px] overflow-hidden overflow-y-auto">
          <div className="flex justify-between w-full align-middle">
            <h2 className="text-xl font-semibold leading-7">Partner Details</h2>
          </div>
          <form id="" className="" onSubmit={(e) => handleFormSubmit(e)}>
            <div className="my-4">
              <label htmlFor="partnerName">Partner Name</label>
              <div>
                <input
                  className="border p-3 w-full rounded-md"
                  type="text"
                  id="partnerName"
                  name="partnerName"
                  defaultValue={partnerData?.partnerName}
                  onChange={(e) => handleFormUpdate(e)}
                  placeholder="Enter partner/organizational name"
                />
              </div>
            </div>

            <div className="my-4">
              <label htmlFor="partnerID">Partner ID</label>
              <div>
                <input
                  className="border p-3 w-full rounded-md"
                  type="text"
                  id="partnerID"
                  name="partnerID"
                  defaultValue={partnerData?.partnerID}
                  onChange={(e) => handleFormUpdate(e)}
                  placeholder="Enter partner ID"
                />
              </div>
            </div>

            <div className="my-4">
              <label htmlFor="partnerType">Partner Type</label>
              <select
                name="partnerType"
                id="partnerType"
                className="w-full"
                value={partnerData?.partnerType}
                onChange={(e) => handleFormUpdate(e)}
              >
                <option disabled selected>
                  Select appointment type
                </option>
                <option value="commercial">Commercial</option>
                <option value="private">Private</option>
              </select>
            </div>

            <div className="my-4">
              <label htmlFor="phoneNumber">Phone Number</label>
              <div>
                <input
                  className="border p-3 w-full rounded-md"
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  defaultValue={partnerData?.phoneNumber}
                  onChange={(e) => handleFormUpdate(e)}
                  placeholder="Enter Phone Number"
                />
              </div>
            </div>

            <div className="my-4">
              <label htmlFor="email">Email</label>
              <div>
                <input
                  className="border p-3 w-full rounded-md"
                  type="email"
                  id="email"
                  name="email"
                  defaultValue={partnerData?.email}
                  onChange={(e) => handleFormUpdate(e)}
                  placeholder="Enter Email"
                />
              </div>
            </div>

            <div className="my-4">
              <label htmlFor="address">Address</label>
              <div>
                <input
                  className="border p-3 w-full rounded-md"
                  type="address"
                  id="address"
                  name="address"
                  defaultValue={partnerData?.address}
                  onChange={(e) => handleFormUpdate(e)}
                  placeholder="Enter Address"
                />
              </div>
            </div>

            {/* <div className="my-4">
              <label htmlFor="address">Address</label>
              <div>
                <input
                  className="border p-3 w-full rounded-md"
                  type="text"
                  id="address"
                  name="address"
                  defaultValue={partnerData?.address}
                  onChange={(e) => handleFormUpdate(e)}
                  placeholder="Enter Address"
                />
              </div>
            </div> */}

            <div className="my-4">
              <label htmlFor="contactName">Contact Person Name</label>
              <div>
                <input
                  className="border p-3 w-full rounded-md"
                  type="text"
                  id="contactName"
                  name="contactName"
                  defaultValue={partnerData?.contactName}
                  onChange={(e) => handleFormUpdate(e)}
                  placeholder="Enter Name"
                />
              </div>
            </div>

            <div className="my-4">
              <label htmlFor="contactPhone">Contact Person Phone</label>
              <div>
                <input
                  className="border p-3 w-full rounded-md"
                  type="tel"
                  id="contactPhone"
                  name="contactPhone"
                  defaultValue={partnerData?.contactPhone}
                  onChange={(e) => handleFormUpdate(e)}
                  placeholder="Enter Phone number"
                />
              </div>
            </div>

            <div className="my-4">
              <label htmlFor="contactEmail">Contact Person Email</label>
              <div>
                <input
                  className="border p-3 w-full rounded-md"
                  type="email"
                  id="contactEmail"
                  name="contactEmail"
                  defaultValue={partnerData?.contactEmail}
                  onChange={(e) => handleFormUpdate(e)}
                  placeholder="Enter email"
                />
              </div>
            </div>

            <div className="my-4">
              <label htmlFor="note">Note</label>
              <div>
                <textarea
                  id="note"
                  name="note"
                  className="border p-3 w-full rounded-md"
                  defaultValue={partnerData?.note}
                  placeholder="Enter a note..."
                  onChange={(e) => handleFormUpdate(e)}
                />
              </div>
            </div>

            <div className="flex justify-end gap-2 py-2 ">
              <button
                type="button"
                onClick={async (e) => {
                  await updateFormData(e);
                  onContinue(e);
                }}
                className="rounded-md text-white bg-primary p-2 w-full lg:w-1/3"
              >
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PartnerForm;
